import React from 'react';

import createIcon from './Icon';

export default createIcon(
  '0 0 28 34',

    <g id="Icon-Set-Filled"  transform="translate(-570.000000, -1037.000000)" fill="#000000">
      <path
        d="M590.535,1060.12 C590.926,1060.51 590.926,1061.14 590.535,1061.54 C590.145,1061.93 589.512,1061.93 589.121,1061.54 L581.465,1053.88 C581.225,1053.64 581.15,1053.31 581.205,1053 C581.15,1052.69 581.225,1052.36 581.465,1052.12 L589.121,1044.46 C589.512,1044.07 590.145,1044.07 590.535,1044.46 C590.926,1044.86 590.926,1045.49 590.535,1045.88 L583.414,1053 L590.535,1060.12 L590.535,1060.12 Z M586,1037 C577.163,1037 570,1044.16 570,1053 C570,1061.84 577.163,1069 586,1069 C594.837,1069 602,1061.84 602,1053 C602,1044.16 594.837,1037 586,1037 L586,1037 Z"
        id="chevron-left-circle" >
      </path>
    </g>
  ,
);
//sketch:type="MSLayerGroup"
//sketch:type="MSShapeGroup"
//
// <g>
//   // <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
//   //
// </g>
// ,

//export default createIcon(
// '0 0 24 24',
// <g id="Icon-Set-Filled" transform="translate(-206.000000, -985.000000)" fill="#000000">
// <path
//       d="M227.685,1009.29 C228.08,1009.69 228.08,1010.33 227.685,1010.72 C227.29,1011.11 226.65,1011.11 226.256,1010.72 L217.284,1001.777 C217.073,1001.568 216.983,1001.29 216.998,1001.016 C216.983,1000.741 217.073,1000.464 217.284,1000.254 L226.256,991.313 C226.65,990.921 227.29,990.921 227.685,991.313 C228.08,991.707 228.08,992.344 227.685,992.736 L219.376,1001.016 L227.685,1009.29 L227.685,1009.29 Z M234,985 L210,985 C207.791,985 206,986.791 206,989 L206,1013 C206,1015.21 207.791,1017 210,1017 L234,1017 C236.209,1017 238,1015.21 238,1013 L238,989 C238,986.791 236.209,985 234,985 L234,985 Z"
//       id="chevron-left-square">
//
//     </path>
//   </g>
// )
// ;
